/* eslint-disable */

import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index';
import Home from '../views/client/Home.vue';
import Dashboard from '../views/admin/Dashboard.vue';
import { isAuthenticated } from '../middleware/router';
import { EventBus } from '../eventBus';
import Volunteer from '../views/client/Volunteer.vue';

Vue.use(Router);

const currYear = new Date().getFullYear();

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/terms-and-conditions',
      name: 'termsConditions',
      component: () => import('../views/client/TermsConditions.vue'),
      meta: {
        title:
          'Terms & Conditions | Leicester Caribbean Carnival | Saturday 1st August 2026',
        tags: [
          {
            name: 'description',
            content:
              'Through Leicester Caribbean Carnival we have been able to keep our Caribbean Culture alive and well in Leicester, other cities in the UK and worldwide.',
          },
          {
            name: 'keywords',
            content:
              'terms, conditions, carnival, leicester, culture, caribbean.',
          },
        ],
      },
    },
    {
      path: '/reserve',
      name: 'reserve',
      component: () => import('../views/client/Reserve.vue'),
      meta: {
        title:
          'Reserve A Stall | Leicester Caribbean Carnival | Saturday 1st August 2026',
        tags: [
          {
            name: 'description',
            content:
              'Through Leicester Caribbean Carnival we have been able to keep our Caribbean Culture alive and well in Leicester, other cities in the UK and worldwide.',
          },
          {
            name: 'keywords',
            content: 'carnival, leicester, culture, caribbean, stall, reserve.',
          },
        ],
      },
    },
    {
      path: '/vendor-form',
      name: 'vendorForm',
      component: () => import('../views/client/VendorForm.vue'),
      meta: {
        title:
          'Vendor Form | Leicester Caribbean Carnival | Saturday 1st August 2026',
        tags: [
          {
            name: 'description',
            content:
              'Through Leicester Caribbean Carnival we have been able to keep our Caribbean Culture alive and well in Leicester, other cities in the UK and worldwide.',
          },
          {
            name: 'keywords',
            content:
              'carnival, leicester, culture, caribbean, vendor, form, vendor form.',
          },
        ],
      },
    },
    {
      path: '/sponsorship-opportunities',
      name: 'vendorForm',
      component: () => import('../views/client/Sponsorship.vue'),
      meta: {
        title:
          'Sponsorship Opportunities | Leicester Caribbean Carnival | Saturday 1st August 2026',
        tags: [
          {
            name: 'description',
            content:
              'Through Leicester Caribbean Carnival we have been able to keep our Caribbean Culture alive and well in Leicester, other cities in the UK and worldwide.',
          },
          {
            name: 'keywords',
            content:
              'carnival, leicester, culture, caribbean, vendor, form, vendor form.',
          },
        ],
      },
    },
    {
      path: '/volunteer',
      name: 'volunteer',
      component: Volunteer,
      meta: {
        title: 'Leicester Caribbean Carnival | Saturday 1st August 2026',
        tags: [
          {
            name: 'description',
            content:
              'Welcome to Leicester Caribbean Carnival 2026. The Carnival will take place at Leicester Victoria Park, Leicester LE1 7RY on Saturday, the 1st August 2026. The theme for this year is Crowned In Culture. All are welcome to celebrate with us from 10am to 8pm.',
          },
          {
            name: 'keywords',
            content: 'carnival, leicester, culture, caribbean.',
          },
        ],
      },
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: 'Leicester Caribbean Carnival | Saturday 1st August 2026',
        tags: [
          {
            name: 'description',
            content:
              'Welcome to Leicester Caribbean Carnival 2026. The Carnival will take place at Leicester Victoria Park, Leicester LE1 7RY on Saturday, the 1st August 2026. The theme for this year is Crowned In Culture. All are welcome to celebrate with us from 10am to 8pm.',
          },
          {
            name: 'keywords',
            content: 'carnival, leicester, culture, caribbean.',
          },
        ],
      },
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/client/About.vue'),
      meta: {
        title: 'About Leicester Caribbean Carnival | Saturday 1st August 2026',
        tags: [
          {
            name: 'description',
            content:
              'It was agreed then, that the first Caribbean Carnival would take place in the City on the first Saturday in August 1985 and on the first Saturday of August each year after that.',
          },
          {
            name: 'keywords',
            content: 'about, carnival, leicester, culture, caribbean.',
          },
        ],
      },
    },
    {
      path: '/carnival',
      name: 'carnival',
      component: () => import('../views/client/Carnival.vue'),
      meta: {
        title: `Carnival Day ${currYear} | Saturday 7th August | Victoria Park`,
        tags: [
          {
            name: 'description',
            content:
              "Carnival Diary, Day Activities & Whats On with performances from Abu Shanti, Soca Village, Viking Sounds & Crew as well as a Fun Fair and children's village.",
          },
          {
            name: 'keywords',
            content: `carnival, leicester, culture, caribbean, ${currYear}`,
          },
        ],
      },
    },
    {
      path: '/tickets',
      name: 'tickets',
      component: () => import('../views/client/Tickets.vue'),
      meta: {
        title:
          'Buy Tickets Now | Leicester Caribbean Carnival | Saturday 1st August 2026',
        tags: [
          {
            name: 'description',
            content:
              'Tickets now available online! Pre booking now live! Free entry for those under 5 years and adults 60+.',
          },
          {
            name: 'keywords',
            content: `tickets, admission , carnival, leicester, culture, caribbean, ${currYear}`,
          },
        ],
      },
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../views/client/Contact.vue'),
      meta: {
        title:
          'Contact Us | Leicester Caribbean Carnival | Saturday 1st August 2026',
        tags: [
          {
            name: 'description',
            content:
              'For all enquiries, get in touch with us at Leicester Caribbean Community Caribbean Carnival CIO, African Caribbean Centre, Maidstone Road, Leicester LE2 0UA, or call 0116 2211793.',
          },
          {
            name: 'keywords',
            content: `Contact, help, carnival, leicester, culture, caribbean, ${currYear}`,
          },
        ],
      },
    },
    {
      path: '/gallery',
      name: 'gallery',
      component: () => import('../views/client/Gallery.vue'),
      meta: {
        title:
          'Gallery| Leicester Caribbean Carnival | Saturday 1st August 2026',
        tags: [
          {
            name: 'description',
            content:
              'For all enquiries, get in touch with us at Leicester Caribbean Community Caribbean Carnival CIO, African Caribbean Centre, Maidstone Road, Leicester LE2 0UA, or call 0116 2211793.',
          },
          {
            name: 'keywords',
            content: `Contact, help, carnival, leicester, culture, caribbean, ${currYear}`,
          },
        ],
      },
    },
    {
      path: '/admin/login',
      name: 'login',
      component: () => import('../views/Login.vue'),
      meta: {
        title: 'Leicester Caribbean Carnival - Login',
      },
    },
    {
      path: '/admin',
      component: Dashboard,
      children: [
        {
          path: 'home',
          name: 'adminHome',
          component: () => import('../views/admin/Home.vue'),
          beforeEnter: isAuthenticated,
          meta: {
            title: 'Leicester Caribbean Carnival - Home Page',
            page: 'home',
            layout: 'admin',
          },
        },
        {
          path: 'about',
          name: 'adminAbout',
          component: () => import('../views/admin/About.vue'),
          beforeEnter: isAuthenticated,
          meta: {
            title: 'Leicester Caribbean Carnival - About Page',
            page: 'about',
            layout: 'admin',
          },
        },
        {
          path: 'carnival',
          name: 'adminCarnival',
          component: () => import('../views/admin/Carnival.vue'),
          beforeEnter: isAuthenticated,
          meta: {
            title: 'Leicester Caribbean Carnival - Carnival Page',
            page: 'carnival',
            layout: 'admin',
          },
        },
        {
          path: 'contact',
          name: 'adminContact',
          component: () => import('../views/admin/Contact.vue'),
          beforeEnter: isAuthenticated,
          meta: {
            title: 'Leicester Caribbean Carnival - Contact Page',
            page: 'contact',
            layout: 'admin',
          },
        },
        {
          path: 'tickets',
          name: 'adminTickets',
          component: () => import('../views/admin/Tickets.vue'),
          beforeEnter: isAuthenticated,
          meta: {
            title: 'Leicester Caribbean Carnival - Tickets Page',
            page: 'tickets',
            layout: 'admin',
          },
        },
        {
          path: 'schedule',
          name: 'scheduler',
          component: () => import('../views/admin/Scheduler.vue'),
          beforeEnter: isAuthenticated,
          meta: {
            title: 'Leicester Caribbean Carnival Scheduler',
            layout: 'admin',
          },
        },
        {
          path: 'settings',
          name: 'settings',
          component: () => import('../views/admin/Settings.vue'),
          beforeEnter: isAuthenticated,
          meta: {
            title: 'Leicester Caribbean Carnival - User Settings',
            layout: 'admin',
          },
        },
        {
          path: 'create-admin',
          name: 'createAdmin',
          component: () => import('../views/admin/AddAdmin.vue'),
          beforeEnter: isAuthenticated,
          meta: {
            title: 'Leicester Caribbean Carnival - Create Admin',
            layout: 'admin',
            noTitle: true,
          },
        },
        {
          path: 'performance-areas',
          name: 'performanceAreas',
          component: () => import('../views/admin/PerformanceAreas.vue'),
          beforeEnter: isAuthenticated,
          meta: {
            title: 'Leicester Caribbean Carnival Performance Areas',
            layout: 'admin',
          },
        },
        {
          path: 'event-info',
          name: 'eventInfo',
          component: () => import('../views/admin/EventInfo.vue'),
          beforeEnter: isAuthenticated,
          meta: {
            title: 'Leicester Caribbean Carnival - Event Information',
            layout: 'admin',
          },
        },
        {
          path: 'history',
          name: 'history',
          component: () => import('../views/admin/Themes.vue'),
          beforeEnter: isAuthenticated,
          meta: {
            title: 'Leicester Caribbean Carnival - Themes History',
            layout: 'admin',
          },
        },
        {
          path: 'images',
          name: 'images',
          component: () => import('../views/admin/Images.vue'),
          beforeEnter: isAuthenticated,
          meta: {
            title: 'Leicester Caribbean Carnival - Images',
            layout: 'admin',
          },
        },
        {
          path: 'files',
          name: 'files',
          component: () => import('../views/admin/Files.vue'),
          beforeEnter: isAuthenticated,
          meta: {
            title: 'Leicester Caribbean Carnival - Files',
            layout: 'admin',
          },
        },
        {
          path: 'footer',
          name: 'footer',
          component: () => import('../views/admin/Footer.vue'),
          beforeEnter: isAuthenticated,
          meta: {
            title: 'Leicester Caribbean Carnival - Footer Area',
            layout: 'admin',
          },
        },
        {
          path: 'newsletter',
          name: 'newsletter',
          component: () => import('../views/admin/Newsletter.vue'),
          beforeEnter: isAuthenticated,
          meta: {
            title: 'Leicester Caribbean Carnival - NewsLetter',
            layout: 'admin',
          },
        },
        {
          path: 'fliers',
          name: 'fliers',
          component: () => import('../views/admin/Flyers.vue'),
          beforeEnter: isAuthenticated,
          meta: {
            title: 'Leicester Caribbean Carnival - Fliers',
            layout: 'admin',
          },
        },
        {
          path: 'galleries',
          name: 'galleriesList',
          component: () => import('../views/admin/Galleries.vue'),
          beforeEnter: isAuthenticated,
          meta: {
            title: 'Leicester Caribbean Carnival - Galleries',
            layout: 'admin',
          },
        },
        {
          path: '/gallery/:id',
          name: 'adminGallery',
          component: () => import('../views/admin/Gallery.vue'),
          beforeEnter: isAuthenticated,
          meta: {
            title: 'Leicester Caribbean Carnival - Manage Gallery',
            layout: 'admin',
          },
        },
        //Error Route commented on Habib's Order
        // {
        //   path: 'errors',
        //   name: 'errors',
        //   component: () => import('../views/admin/Error.vue'),
        //   beforeEnter: isAuthenticated,
        //   meta: {
        //     title: 'Leicester Caribbean Carnival - Error',
        //     layout: 'admin'
        //   }
        // },
      ],
    },
    {
      path: '*',
      name: '404',
      component: () => import('../views/404.vue'),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

export default router;

router.beforeEach((to, from, next) => {
  store.commit('changeLoadingState');
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  // document.head.querySelector('meta[name=description]').content = 'New Description'
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(
    (el) => el.parentNode.removeChild(el),
  );

  setTimeout(() => {
    next();
  }, 500);

  // next();
});

router.afterEach((to, from) => {
  setTimeout(() => {
    EventBus.$emit('setDefaultHamburger');
    store.commit('changeLoadingState', false);
  }, 1500);
});
